import React, { useEffect, useState, useMemo } from 'react';
import { Button, Justify, PagingQuery, notification } from 'tea-component';
import CardSlotV2 from '@/pages/intelligence/components/CardSlotV2';
import SearchRecent from '@/pages/intelligence/components/SearchRecent';
import { SortByItemType } from '@/pages/intelligence/components/TableComponents/components/SortBy';
import '@/pages/intelligence/assets/scss/Following/index.scss';
import {
  TableSelectStatusType,
  TableSelectionType,
} from '@/pages/intelligence/components/TableComponents/components/TableCheckbox';
import {
  fetchFollowingNewGames,
  getFollowingShuttleFrameList,
  createCollectionFollow,
  getCompareEntityTypeSearch,
  followSearchPullDown,
} from '@/pages/intelligence/services/following';
import { TOPGAMENUM } from '@/pages/intelligence/pages/TopCharts/_config/topChartsConst';
import { handleTableDefaultSelectGames } from '@/pages/intelligence/utils/tableUtils';
import NewgamesTable from './Table';
import NewGamesVisualis from './Visualis';
import { RecordItemType } from '@/pages/intelligence/components/SearchRecent/type';
import { getCountryFlag } from '@/pages/home/_config/countries';
import Loading from '@/pages/intelligence/components/Loading';
import FollowingNoData from '@/pages/intelligence/pages/Following/components/FollowingNoData';
import { FILTER_EXTEND_NAMESPACE } from '@/pages/intelligence/models/filterExtend';
import { DBI_TOPCHARTS } from '@/pages/intelligence/models/topcharts';
import { useIntl, connect, useSelector, getLocale } from 'umi';
import useFilterExtend from '@/pages/intelligence/hooks/useFilterExtend';
import * as filterKeyMap from '@/pages/intelligence/components/Filter/FilterBase/_config';
import ExportTable from '@/pages/intelligence/components/ExportTable';
import AddEntities from '@/pages/intelligence/pages/Following/components/AddEntities';
import RenameAddGroup from '../Manage/RenameAddGroup';
import AddGroup from '../Manage/AddGroup';
import { FormMode } from '@/pages/intelligence/pages/TopCharts/_config/enums';
import { MANAGER_GROUP_NAME } from '@/pages/intelligence/pages/Following/_config/constant';
import Filter from '@/pages/intelligence/pages/TopCharts/components/CommonFilter';
import { getDbiFilterParams } from '@intelligence/utils/filterUtils';
import { following } from '@intelligence/v3/constants/downloadLogPoint';

function NewGames(props: any) {
  const {
    loading: isBasicLoading,
    entityType,
    pageLogMes,
    filterState,
    topchartsState,
    setIsUpdateBasicInfo,
    groupOptions,
    DEFAULT_GROUPNAME,
    setUpdateGroupList,
    filterCfg,
    filterLoading,
    hasFollowIds,
  } = props;
  const { formatMessage } = useIntl();
  const locale = getLocale();
  const APPID = 'id'; // 后端返回的游戏id字段

  const DEFAULT_FORM_VALUE = filterCfg?.defaultValue;
  const isOperate = filterState?.isOperate;
  const { filterExtend, setFilterExtend, resetFilterExtend } = useFilterExtend({});
  const [filterValue, setFilterVale] = useState(isOperate ? filterExtend : DEFAULT_FORM_VALUE);

  const DEFAULTPAGESIZE = 20; // 宽表总数据条数
  const newStartData = filterCfg?.resetFilterValue?.[filterKeyMap.DAY_RANGE_TIME]?.value?.[0];
  const newEndData = filterCfg?.resetFilterValue?.[filterKeyMap.DAY_RANGE_TIME]?.value?.[1];

  const cardSlotTitle = formatMessage({
    id: `dbi_top_pheat_value`,
  });
  /** 用于下载 */
  // const [downloadUnifiedIds, setDownloadUnifiedIds] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tableLoading, setTableLoading] = useState(true);
  const [isVisualisLoading, setIsVisualisLoading] = useState(true);
  const [hasFollowData, setHasFollowData] = useState(false);
  const [groupName, setGroupName] = useState(DEFAULT_GROUPNAME);
  const [tableTotal, setTableTotal] = useState(0);
  const [visible, setVisible] = useState(false);
  const [createRenameGroup, setCreateRenameGroup] = useState(false);
  const [addNewGroupName, setAddNewGroupName] = useState('');
  const [mode, setMode] = useState<FormMode>(FormMode.Add);
  const [addGroup, setAddGroup] = useState(false);
  const [group, setGroup] = useState<any>(null);
  const [gameIds, setGameIds] = useState([]);
  const FOLLOWING_TIME_KEY = `${filterKeyMap.RANGE_TIME}_${filterKeyMap.RANGE_TIME_EXTEND_TYPE.singleDate}`;

  const DEFAULT_GROUPNAME1 = useMemo(() => {
    const nameObj =
      entityType == 'company' ? MANAGER_GROUP_NAME.allcompanies : MANAGER_GROUP_NAME.allgames;
    return locale === 'zh-CN' ? nameObj.textcn : nameObj.text;
  }, [entityType, locale]);

  const { userInfo } = useSelector((state: any) => {
    const { userInfo } = state.home;
    return { userInfo };
  });
  // 宽表数据
  const [tableData, setTableData] = useState<any[]>([]);
  // 柱状图、饼图 数据源
  const [barOrPieData, setBarOrPieData] = useState<any[]>([]);
  // 宽表勾选的数据
  const [defaultSelectionGames, setDefaultSelectionGames] = useState<TableSelectionType[]>([]);
  const [tableSelection, setTableSelection] = useState<TableSelectionType[]>([]);
  const [tableListForClearSearch, setTableListForClearSearch] = useState([]);
  const [totalForClearSearch, setTotalForClearSearch] = useState(0);
  const [sortByName, setSortByName] = useState('');
  const [operatedGame, setOperatedGame] = useState(false);
  const [isHandleReset, setIsHandleReset] = useState(false);
  // const [regionOptions, setRegionOptions] = useState([])
  // const [filterLoading, setFilterLoading] = useState(true)
  const [defaultFetchParams, setDefaultFetchParams] = useState({
    entity_type: entityType,
    trace_id: [], // 相当于手游榜单的gamecode,
    search_id: '',
    region_type: 'region',
    regions: ['global'],
    start_date: newStartData,
    end_date: newEndData,
    date_type: 'daily',
    metrics: ['potential'],
    page: 1,
    page_size: DEFAULTPAGESIZE,
    order_field: 'potential',
    order: 'desc',
    group_name: groupName,
  });
  const [fetchParams, setFetchParams] = useState(defaultFetchParams);

  useEffect(() => {
    try {
      if (isBasicLoading || filterLoading) {
        setLoading(true);
      } else {
        let newFetchParams = { ...fetchParams };
        const { filterValue, filterParams } = getDbiFilterParams({
          // urlFilter: any,
          filterSaveData: {}, // filterData?.apiValue,
          filterExtend,
          specialParams: filterCfg?.specialParams,
          isOperate,
          filterName: '',
          filterKeyList: filterCfg?.filterKeyList,
        });
        /** 特殊处理一下不做继承的值：Group ,首次进来使用默认值*/
        const newFilterValue = {
          ...filterValue,
          [filterKeyMap.FOLLOWING_GLOUP]: DEFAULT_FORM_VALUE?.[filterKeyMap.FOLLOWING_GLOUP],
        };
        const newFilterParams = {
          ...filterParams,
          group_name: DEFAULT_FORM_VALUE?.[filterKeyMap.FOLLOWING_GLOUP]?.value,
        };
        if (isOperate) {
          // 如果目前是继承模式，就设置继承值为过滤后的筛选器值
          setFilterExtend(newFilterValue);
        }
        setFilterVale(newFilterValue);
        newFetchParams = {
          ...newFetchParams,
          ...filterCfg?.handleFilterToApiParams(newFilterParams),
        };

        setHasFollowData(hasFollowIds);
        newFetchParams = {
          ...newFetchParams,
          entity_type: entityType,
        };
        // 继承

        if (hasFollowIds) {
          // 获取接口
          getGameData(newFetchParams, false);
        } else {
          // 没有关注游戏，展示无数据
          setLoading(false);
        }
      }
    } catch (err) {
      setLoading(false);
    }
  }, [filterLoading, isBasicLoading, entityType, hasFollowIds /* ogdbIds, followIds*/]);

  const getGameData = async (params: any, isCheckOrSearch: boolean) => {
    if (!hasFollowIds) {
      return;
    }
    try {
      setTableData([]);
      setFetchParams(params);
      const resData = await fetchFollowingNewGames(params);

      const list = resData?.data?.table_list || [];
      const total = resData?.data?.total || 0;
      const req = resData?.req;
      // setDownloadUnifiedIds(resData?.data?.follow_id || []);
      let checkGameList = tableSelection;

      if (params.page === 1) {
        /** 第一页时拿到默认前6个游戏作为游戏全选值 */
        const defaultGames = handleTableDefaultSelectGames(list.slice(0, TOPGAMENUM), APPID);
        setDefaultSelectionGames(defaultGames);
        /** 在第一页且没有勾选游戏时默认选中前6（游戏在排序或重新筛选时有更新） */
        if (!isCheckOrSearch) {
          setTableSelection(defaultGames);
          /** 分页排序请求接口时，可视化不改变 */
          const barOrPieDataTmp = list?.slice(0, TOPGAMENUM);
          setBarOrPieData(barOrPieDataTmp);

          checkGameList = defaultGames;
        }
      }
      if (!params?.search_id) {
        // 有game_code表示是搜索，则不存页面数据
        setTableListForClearSearch(list || []);
        setTotalForClearSearch(total || list?.length);
      }
      if (req) {
        // 如果数据没有正常返回则不设置
        const newFetchParams = {
          ...params,
          date_type: req?.date_type || 'daily',
          start_date: req?.start_date || newStartData,
          end_date: req?.end_date || newEndData,
          /** 当筛选国家数据不一样时，表格要以当前第一个有数据的排序，后端返回 */
          order_field: req?.order_field || params?.order_field,
          order: req?.order || params?.order,
          // ratio_type: req?.ratio_type || params?.ratio_type,
        };
        setFetchParams(newFetchParams);
      }
      setTableTotal(total || list?.length);
      setTableData(list || []);
    } catch (e) {
      console.error(e);
      setTableData([]);
      setBarOrPieData([]);
      setTableSelection([]);
    } finally {
      setLoading(false);
      setIsVisualisLoading(false);
      setTableLoading(false);
    }
  };

  const onTableSortChage = async (e: SortByItemType) => {
    // console.log('eeee', e);
    const newFetchParams = {
      ...fetchParams,
      order: e?.sortVal,
      order_field: e?.ratioType === 1 ? `${e?.sortMetric}_change` : e?.sortMetric,
      // order_source: e?.orderSource,
      // ratio_type: e?.ratioType,
      page: 1,
      page_size: 100,
    };
    setSortByName(e.title);
    setTableLoading(true);
    if (!operatedGame) {
      /** 没有勾选时点排序则重新Loading柱状图数据 */
      setIsVisualisLoading(true);
    }
    await getGameData(newFetchParams, operatedGame);
  };

  const onTablePagingChange = (e: PagingQuery) => {
    const newFetchParams = {
      ...fetchParams,
      page: e?.pageIndex || 1,
      page_size: e?.pageSize || 100,
    };
    setTableLoading(true);
    getGameData(newFetchParams, operatedGame);
  };

  // 表格列表项选择事件回调
  const onTableCheckGame = (
    selectList: TableSelectionType[],
    checkStatus: TableSelectStatusType,
  ) => {
    // setIsNewComfirm(true);
    // setIsNewCheckGame(true);
    const idList = selectList.map((t) => {
      return t?.gameId;
    });
    /** 是否勾选了游戏 */
    if (checkStatus === 'cancel' || checkStatus === 'all' || selectList.length === 0) {
      setOperatedGame(false);
    } else {
      setOperatedGame(true);
    }
    setBarOrPieData(selectList);
    setTableSelection(selectList);
  };

  const handleConfirm = async (value: any) => {
    const newFormValue = {
      ...fetchParams,
      ...value,
      page: 1,
      page_size: 100,
    };
    // 请求接口
    setTableLoading(true);
    setIsVisualisLoading(true);
    /** 修改筛选器后，游戏应该重置为未勾选状态 */
    setOperatedGame(false);
    await getGameData(newFormValue, false);

    // setIsNewComfirm(true);
    // setIsNewCheckGame(true);
  };

  const handleClearSearch = () => {
    setFetchParams({ ...fetchParams, trace_id: [] });
    setTableData(tableListForClearSearch);
    setTableTotal(totalForClearSearch);
  };

  const getTableSearchList = (id: string) => {
    setTableLoading(true);
    getGameData({ ...fetchParams, search_id: id }, true);
  };

  const transTableDataForSearch = (res: any) => {
    const resultList = res?.data?.table_list;
    if (!Array.isArray(resultList) || !resultList?.length) {
      return [];
    }
    const tranksList: RecordItemType[] = resultList.map((item) => {
      return {
        id: item?.[APPID],
        imgSrc: item?.cover,
        lineOneStr: item?.name,
        lineTwoImg: getCountryFlag(item?.markets),
        lineTwoImgName: item?.markets,
        // imageType: '',
        lineTwoStr: item?.publisher,
      };
    });
    return tranksList;
  };

  const onClickNodata = async () => {
    resetFilterExtend();
    const newFetchParams = {
      ...defaultFetchParams,
    };
    setIsHandleReset(true);
    setTableLoading(true);
    setIsVisualisLoading(true);
    /** 修改筛选器后，游戏应该重置为未勾选状态 */
    setOperatedGame(false);
    await getGameData({ ...newFetchParams }, false);
    setIsHandleReset(false);
  };

  const handleFollowConfirm = async (checkedList) => {
    const params = {
      game_company_ids: checkedList,
      entity_type: entityType,
      group_name: ['All Games'],
      user_id: userInfo?.userid,
    };
    setGameIds(checkedList);
    try {
      // TO DO 调用保存的接口
      const res = await createCollectionFollow(params);
      setVisible(false);
      setUpdateGroupList(true);
      // 更新BasicInfo
      setIsUpdateBasicInfo(true);
      // const newFetchParams = {
      //   ...defaultFetchParams,
      //   follow_id: fetchParams.follow_id,
      //   follow_ogdb_id: fetchParams.follow_ogdb_id,
      // };
      // await getGameData({
      //   fetchParams: newFetchParams,
      //   isCheckGame: false,
      //   isSearch: false,
      //   isUpdateLineChart: true,
      // });
      const { destroy } = notification.success({
        unique: true,
        description: (
          <div>
            <span>{formatMessage({ id: 'dbi_success_follow' })}</span>
            <span
              style={{ color: '#326FF0', cursor: 'pointer', marginLeft: 10 }}
              onClick={() => handleAddToGroup(destroy)}
            >
              {formatMessage({ id: 'dbi_add_to_group' })}
            </span>
          </div>
        ),
      });
    } catch (error) {
      notification.error({
        unique: true,
        description: formatMessage({ id: 'dbi_failed_follow' }),
      });
    }
  };

  const handleAddToGroup = (destroy) => {
    destroy?.();
    // 若默认分组只有All Games，在提示点击Add to a Group后弹出Create a New Group弹窗
    if (groupOptions.length === 1 && groupOptions[0]?.value === 'All Games') {
      setCreateRenameGroup(true);
    } else {
      setAddGroup(true);
    }
  };

  const handleChangeSeg = (value) => {
    // 更新Follow接口
    setUpdateGroupList(true);
    // 打开Add to a Group弹窗并选择创建的分组 TODO
    setAddGroup(true);
  };

  const allGameTotal = useMemo(() => {
    const group = groupOptions.find((item) => item.value === 'All Games');
    return group?.game_list_total || 0;
  }, [groupOptions]);

  const handleAddGroupClose = () => {
    setAddGroup(false);
  };

  const getLeftCellTitle = (entityType) => {
    switch (entityType) {
      case 'mobile':
        return 'dbi_top10_pheat';
      case 'pc':
      case 'console':
        return 'dbi_top10_pheat';
      case 'company':
        return 'dbi_top10_sum_rev';
      default:
        return '';
    }
  };

  return (
    <>
      <div className="dbi-following-page-filter">
        <Filter
          isOperate={filterState.isOperate}
          timeFilterValues={{
            type: fetchParams.date_type,
            value: [fetchParams.start_date, fetchParams.end_date],
          }}
          buttonLogConfig={{}}
          filterConfirm={handleConfirm}
          filterReset={() => {}}
          filterInit={() => {}}
          defaultGroupValue={DEFAULT_GROUPNAME}
          groupOptionsData={groupOptions}
          isHandleReset={isHandleReset}
          defaultStartDate={newStartData}
          defaultEnddate={newEndData}
          filterValue={filterValue}
          setFilterVale={setFilterVale}
          defaultValue={DEFAULT_FORM_VALUE}
          FOLLOWING_TIME_KEY={FOLLOWING_TIME_KEY}
          filterCfg={filterCfg}
        />
      </div>
      {loading ? (
        <CardSlotV2 iconList={[]} title={cardSlotTitle}>
          <div style={{ height: 250 }}>
            <Loading />
          </div>
        </CardSlotV2>
      ) : !hasFollowData ? (
        <CardSlotV2 iconList={[]} title={cardSlotTitle}>
          <FollowingNoData
            noFollowData={!hasFollowData}
            entityType={entityType}
            setVisible={setVisible}
            isNewGame={true}
          />
        </CardSlotV2>
      ) : (
        <>
          <NewGamesVisualis
            fetchParams={fetchParams}
            barOrPieData={barOrPieData}
            entityType={entityType}
            loading={tableLoading}
            cardSlotTitle={cardSlotTitle}
          />
          <Justify
            className="dbi-following-justify"
            right={
              <>
                <SearchRecent
                  fetchParams={{ ...fetchParams, page: 1 }}
                  handleClear={handleClearSearch}
                  getTableResultList={getTableSearchList}
                  searchListApi={fetchFollowingNewGames}
                  pageLogInfo={pageLogMes}
                  searchType={`follow_${entityType}_new`}
                  transTableDataForSearch={transTableDataForSearch}
                  initSearchInput={!(fetchParams?.search_id?.length > 0)}
                />

                <ExportTable
                  downloadModalSize={820}
                  entityType={entityType}
                  businessType={'following-newgame'}
                  downloadLogConfigKey={following?.[`${entityType}_new`]}
                  isDisableDownload={tableLoading}
                  total={tableTotal}
                  tableParams={{
                    ...fetchParams,
                    is_following: true,
                  }}
                />
              </>
            }
          />
          <CardSlotV2>
            <NewgamesTable
              APPID={APPID}
              entityType={entityType}
              loading={tableLoading}
              tableTotal={tableTotal}
              records={tableData}
              tableSelection={tableSelection}
              tableSelectionAll={defaultSelectionGames}
              pageSortAttr={{
                tablePageIndex: fetchParams?.page,
                tablePageSize: fetchParams?.page_size,
                currentSortValue: fetchParams?.order,
                currentSortMetric: fetchParams?.order_field,
                currentRatioType: 0,
              }}
              onTableSortChage={onTableSortChage}
              onTablePagingChange={onTablePagingChange}
              onTableCheckGame={onTableCheckGame}
              onClickNodata={onClickNodata}
            />
          </CardSlotV2>
        </>
      )}
      <AddEntities
        entityKey="gameId"
        visible={visible}
        title={formatMessage({
          id: entityType === 'company' ? 'dbi_follow_new_companies' : 'dbi_follow_new_games',
        })}
        onConfirm={handleFollowConfirm}
        entities={{
          game_type: `${entityType}_new`,
          user_id: userInfo?.userid,
        }}
        entityType={entityType}
        pleaseSelectTips={formatMessage({
          id: entityType === 'company' ? 'dbi_please_a_select_company' : 'dbi_please_a_select_game',
        })}
        searchPlaceholder={formatMessage({
          id: entityType === 'company' ? 'dbi_search_any_company' : 'dbi_search_any_game',
        })}
        rightCellTitle={formatMessage({
          id: entityType === 'company' ? 'dbi_company_companies' : 'dbi_games',
        })}
        leftCellTitle={formatMessage({
          id: allGameTotal > 0 ? 'dbi_compare_similar_games' : getLeftCellTitle(entityType),
        })}
        keywordsFetcher={followSearchPullDown}
        entitiesFetcher={getCompareEntityTypeSearch}
        similarEntitiesFetcher={getFollowingShuttleFrameList}
        onClose={() => setVisible(false)}
      />
      <AddGroup
        visible={addGroup}
        close={handleAddGroupClose}
        entityType={entityType}
        addNewGroupName={addNewGroupName}
        isMoveadd={true}
        userInfo={userInfo}
        gameIds={gameIds}
        setUpdateGroupList={setUpdateGroupList}
        setAddGroup={setAddGroup}
        groupOptions={groupOptions.filter((item) => item?.value !== 'All Games')}
        DEFAULT_GROUPNAME={`${DEFAULT_GROUPNAME1} (${allGameTotal})`}
        getCreateGroup={() => {
          setAddGroup(false);
          setMode(FormMode.Add);
          setGroup(null);
          setCreateRenameGroup(true);
        }}
      />
      <RenameAddGroup
        visible={createRenameGroup}
        onConfirm={handleChangeSeg}
        mainSegment={entityType}
        mode={mode}
        setAddNewGroupName={setAddNewGroupName}
        groupNames={groupOptions.map((item) => item.value)}
        setCreateRenameGroup={setCreateRenameGroup}
      />
    </>
  );
}

export default connect((state: any) => {
  return {
    filterState: state[FILTER_EXTEND_NAMESPACE],
    topchartsState: state[DBI_TOPCHARTS],
  };
})(NewGames);
